import React, { useState } from 'react'
import Timeline from '@material-ui/lab/Timeline'
import TimelineItem from '@material-ui/lab/TimelineItem'
import TimelineSeparator from '@material-ui/lab/TimelineSeparator'
import TimelineConnector from '@material-ui/lab/TimelineConnector'
import TimelineContent from '@material-ui/lab/TimelineContent'
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent'
import TimelineDot from '@material-ui/lab/TimelineDot'
import { Alert } from '../Alert'
import { PaperContent } from './components/PaperContent'
import { Typography } from '@material-ui/core'


const initialAlert = {
    open: false,
    onClose: () => { },
    title: '',
    content: '',
    onlyButton: false,
    btn1Txt: '',
    btn2Txt: '',
    btn1Func: () => { },
    btn2Func: () => { }
}


const PqrsTimeline = ({ pqrs }) => {
    const [selected, setSelected] = useState(null)
    const [alertInfo, setAlertInfo] = useState(initialAlert)

    const expandCard = (index) => {
        setSelected(index)
    }

    const signDocAlert = () => {
        setAlertInfo(
            {
                open: true,
                onClose: () => setAlertInfo({ ...alertInfo, open: false }),
                title: '!Espera!',
                content: 'Estás a punto de firmar este documento, ¿deseas continuar?',
                onlyButton: false,
                btn1Txt: 'Continuar',
                btn2Txt: 'Cancelar',
                btn1Func: () => setAlertInfo(initialAlert),
                btn2Func: () => setAlertInfo(initialAlert)
            }
        )
    }
    return (
        <>
            <Alert info={alertInfo} />
            <Timeline align='right'>
                {pqrs.map((item, index) => (
                    <TimelineItem key={item.id}>
                        <TimelineOppositeContent>
                            {
                                item["association-type"] === 1 || item["association-type"] === undefined ?
                                    null
                                    :
                                    <PaperContent item={item} index={index} selected={selected} expandCard={expandCard} signDoc={signDocAlert} />
                            }
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineDot style={{ backgroundColor: 'gray' }} />
                            <TimelineConnector style={{ backgroundColor: 'gray' }} />
                        </TimelineSeparator>
                        <TimelineContent>
                            {
                                item["association-type"] === 2 ?
                                    null
                                    :
                                    <PaperContent item={item} />
                            }
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
        </>
    )
}

export { PqrsTimeline }
